const initialState = {
  status: '',
  errorMessage: '',
  data: {},
};

export default initialState;
